import styles from "../rb22.module.scss"
// import { useContext } from "react"
// import { AppContext } from "../../../utils/context"
// import { printTranslation } from "../../../utils/translations"

// Images
import Open from "../../../assets/images/icons/open.png"
import Close from "../../../assets/images/icons/close.svg"

import Arrow1 from "../../../assets/images/icons/arrow1.svg"
import Arrow3 from "../../../assets/images/icons/arrow3.svg"
import Arrow4 from "../../../assets/images/icons/arrow4.svg"
import Arrow5 from "../../../assets/images/icons/arrow5.svg"
import Arrow6 from "../../../assets/images/icons/arrow6.svg"
import Arrow7 from "../../../assets/images/icons/arrow7.svg"

import { CosmosText, CosmosTitle } from "@cosmos/web-react"

// Returns the HTML markup for the toucpoint
export default function Touchpoint({ id, translationKey, active, setActive, title, content }) {
	// Check to see if the touchpoint is active
	const isActive = id === active

	// Get the language from the context
	// const { lang } = useContext(AppContext)

	// Get the translations for the content
	// const translatedTitle = printTranslation(`${translationKey}_Title`, lang, title)
	// const translatedContent = printTranslation(`${translationKey}_Content`, lang, content)

	return (
		<div
			className={[styles.touchpoint, styles[id], active && active !== id ? styles.hide : ""].join(" ")}
			onClick={() => setActive(id)}>
			{id === "frontWing" && (
				<img
					className={styles.arrow}
					src={Arrow1}
					alt="Arrow"
				/>
			)}
			{id === "halo" && (
				<img
					className={styles.arrow}
					src={Arrow3}
					alt="Arrow"
				/>
			)}
			{id === "bargeBoards" && (
				<img
					className={styles.arrow}
					src={Arrow4}
					alt="Arrow"
				/>
			)}
			{id === "floor" && (
				<img
					className={styles.arrow}
					src={Arrow5}
					alt="Arrow"
				/>
			)}
			{id === "tyres" && (
				<img
					className={styles.arrow}
					src={Arrow6}
					alt="Arrow"
				/>
			)}
			{id === "rearWing" && (
				<img
					className={styles.arrow}
					src={Arrow7}
					alt="Arrow"
				/>
			)}

			<div className={styles.title}>
				<img
					className={styles.open}
					src={Open}
					alt="Open"
				/>
				<CosmosText
					size="medium"
					weight="bold">
					{/* {translatedTitle} */}
					{title}
				</CosmosText>
			</div>

			<div className={[styles.content, isActive ? styles.isShowing : ""].join(" ").trim()}>
				<img
					className={styles.closeTouchpoint}
					src={Close}
					alt="Close"
				/>
				{/* <img className={styles.border} src={Border} alt="Lower Border" /> */}

				<CosmosTitle
					spacing="long-form-bottom"
					size="small"
					style={{ paddingRight: `30px` }}>
					{/* {translatedTitle} */}
					{title}
				</CosmosTitle>
				<CosmosText size="x-small">
					{/* {translatedContent} */}
					{content}
				</CosmosText>
			</div>
		</div>
	)
}
